<template>
  <div class="chat container">
    <div class="row" >
          <div class="col s12 m6 l5">
            <div v-for="freund in this.freundeinformation" :key="freund.id" style="margin-bottom: -20px">
                  <div class="card">
                    <div class="card-image">
                      <div class="row">
                        <div class="col s4">
                          <img v-bind:src="freund.img" height="100px" width="100px">
                          <span class="card-title">{{freund.name}}</span>
                        </div>
                        <div class="col s1">
                          <div class="card-action">
                            <a  @click="privat(freund)">Chat</a>
                            <a  @click="anzeigen(freund)">Anzeigen</a>
                            <a  @click="removing(name, freund.name)">Entfernen</a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
            </div>
          </div>
          <div class="col s12 m6 l7">
              <div class="card" v-if="alluser" >
                <div class="card-content" >
                  <h5 class="grey-text text-darken-h4">Privat Chat: {{name}}</h5>
                  <ul class="messages" v-chat-scroll style="border-style: solid;border-width: 1px;">
                    <li v-for="message in messages" :key="message.id">
                      <span class="grey-text time blue-grey lighten-4">{{message.timestamp}}</span>
                      <span class="text name blue-grey lighten-2">{{message.name}}</span>
                      <span class="grey-text text-darken-h3 content">{{message.content}}</span>
                    </li>
                  </ul>
                </div>
                <div class="card action">
                  <NewMessage :name="name"></NewMessage>
                  <input type="text">
                </div>
              </div>
              <div v-if="!alluser" >
                  <div class="card" >
                    <div class="card-image" style="margin-left: 30px;padding-top: 20px">
<!--                      <img src="../../assets/imgs/user_small.jpg" style="height: 200px; width: 300px">-->
                      <img v-bind:src="freund.img" style="height: 200px; width: 300px">
                      <span class="card-title">{{freund.name}} </span>
                    </div>
                    <div class="card-content" >
                      <p>I am a very simple card.
                        bits of information.I am a very simple card.
                        bits of information.I am a very simple card.
                        bits of information.I am a very simple card.
                        bits of information.I am a very simple card.
                        bits of information.I am a very simple card.
                      </p>
                    </div>
                    <div class="card-action" >
                      <p>Age:{{freund.alter}}</p>
                    </div>
                    <div class="card-action" >
                      <p> Region: {{freund.region}}</p>
                    </div>
                    <div class="card-action">
                      <a @click="zuruck">Zurück</a>
                    </div>
                  </div>
                </div>
          </div>
    </div>
  </div>
</template>

<script>
    import NewMessage from "@/components/NewMessage"
    import Button from '@/components/Button'
    import {modulgetRefDBWhere} from "../../firebase/MainDBManager";
    import {modulgetChats, modulgetChatsOnlyName,  modulgetFriends} from "../../firebase/PrivatChatDBFunction"
    import {modulremoveArrayElement} from "../../firebase/GlobalDBFunctions"
    export default {
        name: "PrivatChat",
        props: ['name', 'neuePerson'],

        components: {
            NewMessage,
            Button
        },
        data() {
            let ref;
            let ref2;
            return {
                messages: [],
                arr : [],
                inputs:[],
                holder:this.name,
                holder2:this.neuePerson,
                alluser:true,
                index:0,
                onlineusers: [],
                freunde:[],
                freundeinformation:[],
                freund:[],
                ref,
                ref2,
            }
        },
        methods:{
            anzeigen: function(freund){
                this.alluser=false;
                this.freund=freund;
            },
            privat: function(freund){
                this.alluser=true;
                this.neuePerson=freund.name;
                this.getChats();
            },
            zuruck: function(){
                this.alluser=true;
            },
            removing:function (name,nameRemove) {
                this.ref=modulgetRefDBWhere("friends", 'name', name);
                modulremoveArrayElement(this.ref, name, nameRemove,this.$router);
                this.getChatsOnlyName();
                this.getFriends();
            },

            getFriends:function(){
                this.ref=modulgetRefDBWhere("friends",'name',this.name)
                this.freundeinformation=modulgetFriends(this.ref,this.name);
            },
            getChats: function () {
                this.ref =modulgetRefDBWhere("messages", 'name', this.name);
                this.ref2=modulgetRefDBWhere("messages", 'name', this.neuePerson);
                this.messages = modulgetChats(this.ref, this.ref2, this.messages, this.name, this.neuePerson);
            },
            getChatsOnlyName: function () {
                this.ref =modulgetRefDBWhere("messages", 'name', this.name);
                this.messages = modulgetChatsOnlyName(this.ref,this.messages, this.name);
            }
        },
        computed: {
            uniqueNames: function() {
                let messagesnew = [];
                for(let i =0; i < this.messages.length; i++) {
                    if(messagesnew.indexOf(this.messages[i].name) === -1) {
                        messagesnew.push(this.messages[i].name)
                    }
                }
                return messagesnew;
            }
        },
        mounted(){
            this.getChats();
            this.getFriends();
        },
        created() {
        }
    }
</script>

<style scoped>
  .chat h2{
    font-size: 2.6em;
    margin-bottom: 40px;
  }
  .chat span{
    font-size: 1.5em;
  }
  .chat .time{
    font-size: 0.9em;
  }
  .chat .name{
    text-align: right;
    width: 40px;
    font-size: 1.0em;
  }
  .chat .content{
    margin-left: 5px;
    font-size: 1.1em;
  }
  .messages {
    max-height: 200px;
    overflow: auto;

  }
  .messages::-webkit-scrollbar{
    width: 3px;
  }
  .messages::-webkit-scrollbar-track{
    background: #ddd;
  }
  .messages::-webkit-slider-thumb{
    background:#aaa;
  }

</style>



// WEBPACK FOOTER //
// src/components/Chat/PrivatChat.vue